<ion-content [scrollY]="false">
  @if (state.inProgressActivityId) {
    <dojo-examdojo-question
      (completed)="handleCompletedQuestion($event)"
      [isTransitioningBetweenQuestions]="state.isTransitioningBetweenQuestions"
      [footerTemplateRef]="footerTemplate"
    />
  } @else {
    @if (state.isLoading) {
      <dojo-loader class="flex h-full items-center justify-center" />
    } @else {
      @if (state.ongoingActivityId && state.candidates; as candidates) {
        <dojo-question-selection
          @appearDisappear
          [questionCandidates]="candidates"
          (candidateSelected)="handleCandidateSelected($event)"
          (cancelled)="handleCompletedQuestion('stop')"
        />
      }
    }
  }
</ion-content>

<ng-template #footerTemplate>
  @if (isDesktop || !isCanvasVisible()) {
    @if (state.isSmall) {
      <dojo-question-footer-mobile
        [isReadyToGrade]="questionComponent()?.isReadyToGrade() ?? false"
        [overrideNextLabel]="state.isMultiQuestionActivity && state.areAllQuestionsCompleted ? 'finish' : undefined"
        [processingAction]="processingAction()"
        (selfGrade)="questionComponent()?.selfGradeQuestionAttempt()"
        (mcqGrading)="questionComponent()?.multipleChoiceQuestionGrading()"
        (submitForGrading)="questionComponent()?.submitForGrading()"
        (nextQuestion)="questionComponent()?.goToNextQuestion()"
      />
    } @else {
      <dojo-question-footer-desktop
        [isReadyToGrade]="questionComponent()?.isReadyToGrade() ?? false"
        [overrideNextLabel]="state.isMultiQuestionActivity && state.areAllQuestionsCompleted ? 'finish' : undefined"
        [processingAction]="processingAction()"
        (endPractice)="questionComponent()?.endPractice()"
        (selfGrade)="questionComponent()?.selfGradeQuestionAttempt()"
        (mcqGrading)="questionComponent()?.multipleChoiceQuestionGrading()"
        (submitForGrading)="questionComponent()?.submitForGrading()"
        (nextQuestion)="questionComponent()?.goToNextQuestion()"
      />
    }
  }
</ng-template>
